import React from 'react';
import { Typography } from 'antd';
import SettingsRowShell from './SettingsRowShell';
import SettingsPillButton from './SettingsPillButton';

const { Text } = Typography;

interface SettingsRowProps {
  label: string;
  value?: React.ReactNode;
  actionLabel: string;
  onAction: () => void;
}

/**
 * "Label + muted value on the left, pill Edit/Change button on the right"
 * row used throughout the redesigned Settings page (Información personal,
 * and anywhere else that needs the same one-field-at-a-time edit pattern).
 */
const SettingsRow: React.FC<SettingsRowProps> = ({ label, value, actionLabel, onAction }) => (
  <SettingsRowShell
    left={
      <div>
        <Text style={{ fontSize: 15 }}>{label}</Text>
        {value != null && (
          <div style={{ marginTop: 2 }}>
            <Text type="secondary">{value}</Text>
          </div>
        )}
      </div>
    }
    right={<SettingsPillButton onClick={onAction}>{actionLabel}</SettingsPillButton>}
  />
);

export default SettingsRow;
